/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Listing_Category_YachtInputs */

const en_listing_category_yacht = /** @type {(inputs: Listing_Category_YachtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yacht`)
};

const es_listing_category_yacht = /** @type {(inputs: Listing_Category_YachtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yates`)
};

const fr_listing_category_yacht = /** @type {(inputs: Listing_Category_YachtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yacht`)
};

const de_listing_category_yacht = /** @type {(inputs: Listing_Category_YachtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yachten`)
};

const ja_listing_category_yacht = /** @type {(inputs: Listing_Category_YachtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ヨット`)
};

const zh_listing_category_yacht = /** @type {(inputs: Listing_Category_YachtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`游艇`)
};

const ar_listing_category_yacht = /** @type {(inputs: Listing_Category_YachtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`يخوت`)
};

const id_listing_category_yacht = /** @type {(inputs: Listing_Category_YachtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kapal Pesiar`)
};

const it_listing_category_yacht = /** @type {(inputs: Listing_Category_YachtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yacht`)
};

const ru_listing_category_yacht = /** @type {(inputs: Listing_Category_YachtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Яхты`)
};

const pt_listing_category_yacht = /** @type {(inputs: Listing_Category_YachtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iates`)
};

const ko_listing_category_yacht = /** @type {(inputs: Listing_Category_YachtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`요트`)
};

/**
* | output |
* | --- |
* | "Yacht" |
*
* @param {Listing_Category_YachtInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const listing_category_yacht = /** @type {((inputs?: Listing_Category_YachtInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Listing_Category_YachtInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_listing_category_yacht(inputs)
	if (locale === "es") return es_listing_category_yacht(inputs)
	if (locale === "fr") return fr_listing_category_yacht(inputs)
	if (locale === "de") return de_listing_category_yacht(inputs)
	if (locale === "ja") return ja_listing_category_yacht(inputs)
	if (locale === "zh") return zh_listing_category_yacht(inputs)
	if (locale === "ar") return ar_listing_category_yacht(inputs)
	if (locale === "id") return id_listing_category_yacht(inputs)
	if (locale === "it") return it_listing_category_yacht(inputs)
	if (locale === "ru") return ru_listing_category_yacht(inputs)
	if (locale === "pt") return pt_listing_category_yacht(inputs)
	return ko_listing_category_yacht(inputs)
});